import antdEnUS from 'antd/es/locale/en_US';
import antdZhCn from 'antd/es/locale/zh_CN';
import antdFrFR from 'antd/es/locale/fr_FR';
import antdJaJP from 'antd/es/locale/ja_JP';
import en from './locales/en_US.json'
import zh from './locales/zh_CN.json'
import fr from './locales/fr_FR.json'
import ja from './locales/ja_JP.json'
import uz from './locales/uz_UZ.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { THEME_CONFIG } from 'configs/AppConfig';

// antd has no bundled uz_UZ locale — fall back to en_US for antd components
// (DatePicker, Pagination, etc.). App UI strings come from uz_UZ.json.
export const resources = {
    en: {
        translation: en,
        antd: antdEnUS
    },
    zh: {
        translation: zh,
        antd: antdZhCn
    },
    fr: {
        translation: fr,
        antd: antdFrFR
    },
    ja: {
        translation: ja,
        antd: antdJaJP
    },
    uz: {
        translation: uz,
        antd: antdEnUS
    },
}

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: 'en',
    lng: THEME_CONFIG.locale,
    // Locale files use flat dotted keys (e.g. "sidenav.dashboard.default").
    // Disabling separators makes flat lookups explicit and lets literal
    // Uzbek strings with numbers/dots (e.g. "1.1 …") pass through untouched.
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
        escapeValue: false
    }
})

export default i18n;
